import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

// shared result of the notification-bell lead resolvers (getActiveUserSetLeads, getAddedAssignedUserLeads)
export const schemaLoanRequestNotificationLeads = z.array(
    LoanRequestsTableDefinitionZod.extend({ isProcessed: z.boolean() }),
);

export type SchemaLoanRequestNotificationLeads = z.infer<typeof schemaLoanRequestNotificationLeads>;

export type LoanRequestNotificationLeadsResolver = Resolver<Arguments, SchemaLoanRequestNotificationLeads>;
